"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanySubscriptionListResDTO = void 0;
class CompanySubscriptionListResDTO {
    constructor(data) {
        this.subscriptionId = data.subscriptionId;
        this.companyId = data.companyId;
        this.createdAt = data.createdAt;
        this.status = data.status;
        this.onTrial = data.onTrial;
        this.expiresAt = data.expiresAt;
        this.trialExpiresAt = data.trialExpiresAt;
        this.canceledAt = data.canceledAt;
        this.updatedAt = data.updatedAt;
        this.providerProductId = data.providerProductId;
        this.extensionPackages = data.extensionPackages;
        this.requires3DSecureConfirmation = data.requires3DSecureConfirmation;
        this.threeDomainSecureFinalized = data.threeDomainSecureFinalized;
        this.client_secret = data.client_secret || null;
        this.priceAfterDiscount = null;
    }
}
exports.CompanySubscriptionListResDTO = CompanySubscriptionListResDTO;
